import React from 'react';
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Grid,
  Chip,
  Typography,
  IconButton,
  Tooltip
} from '@mui/material';
import {
  Search as SearchIcon,
  Clear as ClearIcon,
  FilterList as FilterIcon
} from '@mui/icons-material';

const SearchAndFilter = ({
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Search...',
  filters = [],
  onFilterChange,
  onClearFilters,
  showClearButton = true
}) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            InputProps={{
              startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />
            }}
          />
        </Grid>
        
        {filters.map((filter, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <FormControl fullWidth>
              <InputLabel>{filter.label}</InputLabel>
              <Select
                value={filter.value}
                onChange={(e) => onFilterChange(filter.key, e.target.value)}
                label={filter.label}
              >
                {filter.options.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        ))}
        
        {showClearButton && (
          <Grid item xs={12} sm={6} md="auto">
            <Button
              variant="outlined"
              startIcon={<ClearIcon />}
              onClick={onClearFilters}
              sx={{ height: '56px' }}
            >
              Clear Filters
            </Button>
          </Grid>
        )}
      </Grid>
      
      {/* Active Filters Display */}
      {filters.some(filter => filter.value && filter.value !== '') && (
        <Box sx={{ mt: 2, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          <Typography variant="body2" sx={{ alignSelf: 'center', mr: 1 }}>
            Active filters:
          </Typography>
          {filters.map((filter, index) => {
            if (!filter.value || filter.value === '') return null;
            const option = filter.options.find(opt => opt.value === filter.value);
            return (
              <Chip
                key={index}
                label={`${filter.label}: ${option?.label || filter.value}`}
                onDelete={() => onFilterChange(filter.key, '')}
                size="small"
                color="primary"
                variant="outlined"
              />
            );
          })}
        </Box>
      )}
    </Box>
  );
};

export default SearchAndFilter;
